import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Container } from 'reactstrap';

const logos = [
  {
    name: 'Amazon',
    image: '/images/logos/Amazon_logo.svg.png',
  },
  {
    name: 'eBay',
    image: '/images/logos/EBay_logo.svg.png',
  },
  {
    name: 'AliExpress',
    image: '/images/logos/Aliexpress_logo.svg.png',
  },
  {
    name: 'Walmart',
    image: '/images/logos/Walmart_logo_(2008).svg.png',
  },
  {
    name: 'Facebook',
    image: '/images/logos/Facebook_Logo_(2019).svg.png',
  },
  {
    name: 'TikTok',
    image: '/images/logos/TikTok_logo.svg.png',
  },
  {
    name: 'Shopify',
    image: '/images/logos/Shopify_logo_2018.svg.png',
  },
];

const LogoMarquee: React.FC = () => {
  const prefersReducedMotion = useReducedMotion();

  // Double the logos for seamless infinite scroll
  const duplicatedLogos = [...logos, ...logos];

  return (
    <section className="logo-marquee-section">
      <Container>
        <motion.div
          className="marquee-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
        >
          <span className="marquee-label">Trusted by dropshippers worldwide</span>
          <h3 className="marquee-title">
            Connect with <span className="highlight">leading marketplaces</span>
          </h3>
        </motion.div>
      </Container>

      <div className="marquee-wrapper">
        <div className="marquee-gradient left" />
        <div className="marquee-gradient right" />

        <motion.div
          className="marquee-track"
          animate={prefersReducedMotion ? {} : {
            x: ['0%', '-50%'],
          }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop" as const,
              duration: 30,
              ease: "linear" as const,
            },
          }}
        >
          {duplicatedLogos.map((logo, index) => (
            <div key={`${logo.name}-${index}`} className="logo-item">
              <div className="logo-inner">
                <img
                  src={logo.image}
                  alt={logo.name}
                  className="logo-image"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default LogoMarquee;
